export type NestedSurfaceBg = "bg-secondary" | "bg-muted";

export function resolveNestedSurfaceBg(
  element: HTMLElement | null
): NestedSurfaceBg {
  let el = element;
  while (el) {
    const hasCardOrMutedBg = [...el.classList].some(
      (className) =>
        className === "bg-card" ||
        className === "bg-muted" ||
        className.startsWith("bg-muted/")
    );
    if (hasCardOrMutedBg) return "bg-secondary";
    el = el.parentElement;
  }
  return "bg-muted";
}
